import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export enum Section {
  TEMPLATE = 'template',
  CAPABILITIES = 'capabilities',
  ABOUT_US = 'about-us',
  CONTACT = 'contact',
  LOGO = 'logo'
}

export interface WebsiteProgressPayload {
  companyId: number;
  completionPercentage: number;
  currentSection: string;
  websiteUrl?: string;
}

export interface SectionCompletionStates {
  isThemeCompleted: boolean;
  isCapabilitiesCompleted: boolean;
  isAboutCompleted: boolean;
  isContactCompleted: boolean;
  isLogoCompleted: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class WebsiteProgressService {

  constructor(private http: HttpClient) {}

  /**
   * Calculate completion percentage based on completed sections using enum-based approach
   */
  calculateCompletionPercentage(completionStates: SectionCompletionStates): number {
    const sectionCompletions = [
      { section: Section.TEMPLATE, completed: completionStates.isThemeCompleted },
      { section: Section.CAPABILITIES, completed: completionStates.isCapabilitiesCompleted },
      { section: Section.ABOUT_US, completed: completionStates.isAboutCompleted },
      { section: Section.CONTACT, completed: completionStates.isContactCompleted },
      { section: Section.LOGO, completed: completionStates.isLogoCompleted }
    ];
    
    const completedCount = sectionCompletions.filter(s => s.completed).length;
    if(completedCount === 5){
      return 95;
    }
    return Math.round((completedCount / sectionCompletions.length) * 100);
  }

  
  updateWebsiteProgress(
    companyId: string, 
    currentSection: string, 
    completionPercentage: number,
    websiteUrl?:string
  ): Observable<any> {
    const payload: WebsiteProgressPayload = {
      companyId: parseInt(companyId),
      completionPercentage: completionPercentage,
      currentSection: currentSection,
      websiteUrl: websiteUrl
    };

    console.log('WebsiteProgressService: Sending progress update:', payload);

    return this.http.post(
      `${environment.dynamoApiBaseUrl}/supplier/UpdateWebsiteProgress`, 
      payload
    );
  }

  
}
